/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

/**
 * Validation de l'étape « Déclarant ».
 *
 * Volontairement minimale : nom de famille et prénom usuel, et la cohérence de
 * l'âge s'il est saisi.
 *
 * ⚠️ Ni l'âge, ni la profession, ni le domicile ne sont exigés, bien qu'ils
 * soient presque toujours renseignés en base : c'est un outil de NUMÉRISATION,
 * la source est l'acte papier. Bloquer sur un champ absent de l'original
 * empêcherait de numériser l'acte — alors que l'identité, elle, y figure
 * toujours.
 *
 * Le déclarant n'a **pas** de date de naissance mais un ÂGE (`ai_age`), d'où une
 * validation propre plutôt qu'un appel à `validationInformationsNaissance`.
 *
 * Les erreurs sont regroupées sous `declarant`, comme l'étape des parents les
 * regroupe sous `parent1`/`parent2`.
 */
const validationStepDeclarant = (data: Record<string, any>) => {
  const declarant = data?.declarant ?? {};

  const errors = {
    nomFamille: '',
    prenom: '',
    age: '',
  };

  if (_.isEmpty(declarant?.nomFamille)) {
    errors.nomFamille = 'Le nom de famille est obligatoire';
  }

  if (_.isEmpty(declarant?.prenom)) {
    errors.prenom = 'Le prénom usuel est obligatoire';
  }

  const age = _.toString(declarant?.age);

  if (!_.isEmpty(age)) {
    const valeur = Number(age);
    if (!Number.isInteger(valeur) || valeur < 0 || valeur > 130) {
      errors.age = "L'âge est invalide";
    }
  }

  const erreurs = _.pickBy(errors, (value) => value !== '');

  return _.isEmpty(erreurs) ? {} : { declarant: erreurs };
};

export default validationStepDeclarant;
